import React from "react"
import { Link } from "react-router-dom"
import "../../assets/css/common.css"
import { t } from '../../components/i18n/i18n'
import back from "../../assets/images/elements/aboutHeader.jpg"; // Можна замінити на профільне фото або інший фон
import articlePdf from "../../resources/3_nehemiah.pdf"

export const Article3_Nehemiah = () => {
    return (
        <section className='text_container_light'>
            <div className='container_100'>
                {/* Верхній блок з заголовком (як у About) */}
                <div className='backImg15'>
                    <img src={back} alt='' />
                    <div className='text_container_dark_15'>
                        <div className='h1_15'>{t("resourceArticle3Title")}</div>
                    </div>
                </div>

                <br />

                <div className='container boxItems'>
                    {/* Кнопка повернення */}
                    <Link to='/resources' style={{textDecoration: 'none', color: '#777'}}>
                        {t("resourceBackToList")}
                    </Link>
                    <br /><br />

                    <div className='article_grid'>
                        {/* ЛІВА КОЛОНКА: Метадані та Анотація */}
                        <div>
                            <h2 className='menuColor'>{t("resourceArticle3Title")}</h2>

                            <p>{t("resourceArticle3Author")}</p>

                            <div style={{ marginTop: '10px' }}>
                                <a
                                    href={articlePdf}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="pdf-download-link"
                                    style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        color: '#b22222',
                                        textDecoration: 'none',
                                        fontWeight: 'bold',
                                        fontSize: '14px'
                                    }}
                                >
                                    <span style={{ marginRight: '8px' }}>📄</span>
                                    {t("resourceArticleDownloadOriginal")}
                                </a>
                            </div>

                            <hr />
                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle3AnnotationHeader")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3Annotation") }} /></p>

                            <br />
                            <h3 className='menuColor'>{t("resourceArticle3Sec0")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3P0_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3P0_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3P0_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3P0_4") }} /></p>

                            <br />
                            <h3 className='menuColor'>{t("resourceArticle3Sec1")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3P1_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3P1_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3P1_3") }} /></p>

                            <br />
                            <h3 className='menuColor'>{t("resourceArticle3Step1Header")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3Step1Content") }} /></p>
                            <br />
                            <h3 className='menuColor'>{t("resourceArticle3Step2Header")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3Step2Content") }} /></p>
                            <br />
                            <h3 className='menuColor'>{t("resourceArticle3Step3Header")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3Step3Content") }} /></p>
                            <br />
                            <h3 className='menuColor'>{t("resourceArticle3Step4Header")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3Step4Content") }} /></p>

                        </div>

                        {/* ПРАВА КОЛОНКА: Основний зміст */}
                        <div>


                            <h3 className='menuColor'>{t("resourceArticle3Step5Header")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3Step5Content") }} /></p>
                            <br />
                            <h3 className='menuColor'>{t("resourceArticle3Step6Header")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3Step6Content") }} /></p>
                            <br />
                            <h3 className='menuColor'>{t("resourceArticle3Step7Header")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3Step7Content") }} /></p>

                            <br/>

                            <h3 className='menuColor'>{t("resourceArticle3Sec2")}</h3>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3P2_1") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3P2_2") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3P2_3") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3P2_4") }} /></p>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3P2_5") }} /></p>


                            <br/>
                            <p><div dangerouslySetInnerHTML={{ __html: t("resourceArticle3Bibliography") }} /></p>

                            <hr />
                            <p style={{ fontSize: '13px', color: '#999', marginTop: '10px' }}>
                                {t("resourceArticle3Copyright")}
                            </p>
                            <br/>

                        </div>
                    </div>
                </div>
                <br />
            </div>
        </section>
    )
}
